<div class="modal-header">
  <h3 class="modal-title" id="modal-title">Sök leverantör</h3>
</div>

<div class="modal-body p-3">
    <rask-tabs layout="header"
        [wrap]="true" [useRoute]="false" [initialTabId]="selectedTab">
        <rask-tab tabId="Leverantörsregistret" label="Leverantörsregistret">
            <ng-container [ngTemplateOutlet]="loading"></ng-container>
        </rask-tab>
        <rask-tab icon="fa-solid fa-map" iconPosition="right" tabId="Fastighetsregistret" label="Fastighetsregistret">
            <rask-vk-karta-fastigheter (imported)="fastighetImported($event)"></rask-vk-karta-fastigheter>
            <div class="modal-footer">
                <rask-button aid="buttonLevAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus>stäng</rask-button>
            </div>
        </rask-tab>
    </rask-tabs>
</div>

<ng-template #loading>
    <div class="row">
        <div class="col-md-6">
            <rask-input class="full" label="Namn, ort eller Pnr/Orgnr" [(ngModel)]="searchNameCityPnr"
                placeholder="Namn, ort eller Pnr/Orgnr"></rask-input>
        </div>
        <div class="col-md-6 full">
            <rask-input class="full" label="Adress" [(ngModel)]="searchAddress"
                placeholder="Address"></rask-input>
        </div>
    </div>
    <div class="row searchrow">
        <div class="col-md-3">
            <rask-input class="full" label="leverantörsnr" [(ngModel)]="searchLeverantorsnummer"
                placeholder="Leverantörsnummer">
            </rask-input>
        </div>
        <div class="col-md-3">
            <rask-input class="full" label="telefonnummer" [(ngModel)]="searchPhonenumber"
                placeholder="Telefonnummer"></rask-input>
        </div>
        <div class="col-md-6">
            <rask-search
                aid="inputAnsvarigVirkeskopare"
                col="col-12"
                label="Ansv Virkesköpare"
                placeholder="Ansv virkesköpare"
                bindLabel="namn"
                bindValue="kod"
                typeToSearchText="{{ 'LEVERANTOR_DETAIL_TYPE_AHEAD_HELP_TEXT' | translate }}"
                loadingText="Laddar..."
                notFoundText="Ingen träff"
                [minTermLength]="3"
                [typeaheadFn]="getAnvandareTypeAhead"
                [selected]="searchAnsvarigvirkeskopare"
                [compareWith]="ansvarigVirkeskopareCompareWith"
                (selectedChanged)="ansvarigVirkeskopareChanged($event)">
            </rask-search>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <rask-textmultiline class="full" label="">
                <rask-button
                    aid="buttonLevSok"
                    color="secondary"
                    (click)="search()"
                    [disabled]="isSearching"
                    class="searchbutton">
                    @if (isSearching) {
                    <rask-busy-spinner size="1"></rask-busy-spinner>
                    }
                    @else{
                    <i class="far fa-search"></i>
                    }
                    <span class="ms-1">Sök</span>
                </rask-button>
            </rask-textmultiline>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-md-12">
            @if (leverantorer?.length > 0) {
            <div class="ms-3">Sökresultat: {{ leverantorer.length }} träffar</div>
            <rask-list [fixedHeader]="true" [virtualScroll]="true" [virtualScrollItemHeight]="79" [data]="leverantorer">
                <rask-list-column header="Namn" field="namn" width="150px"></rask-list-column>
                <rask-list-column header="Person/Orgnr" field="orgnr" width="100px"></rask-list-column>
                <rask-list-column header="Adress" field="adress" width="130px"></rask-list-column>
                <rask-list-column header="Telefonnummer" field="telefon"></rask-list-column>
                <rask-list-column header="Leverantörsnr" field="limeId"></rask-list-column>
                <rask-list-column>
                    <ng-template let-row="row">
                        <div style="line-height: 64px">
                            <rask-checkbox [(ngModel)]="row.checked"></rask-checkbox>
                        </div>
                    </ng-template>
                </rask-list-column>
            </rask-list>
            }
        </div>
    </div>
    @if (resultMessage) {
    <div class="message">
        <span><i>{{resultMessage}}</i></span>
    </div>
    }
    <div class="modal-footer">
        <rask-button aid="buttonLevLaggTill" color="primary" (click)="add()" [disabled]="!canAdd()">Lägg till
            leverantör</rask-button>
        <rask-button aid="buttonLevAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus>Avbryt</rask-button>
    </div>
</ng-template>